(function () {
	let codemod = (function () {
		'use strict';

		const global = tinymce.util.Tools.resolve('tinymce.PluginManager');

		const global$1 = tinymce.util.Tools.resolve('tinymce.dom.DOMUtils');

		const getMinWidth = function (editor) {
			return editor.getParam('codemod_dialog_width', 600);
		};
		const getMinHeight = function (editor) {
			return editor.getParam('codemod_dialog_height', Math.min(global$1.DOM.getViewPort().h - 200, 500));
		};
		const Settings = {
			getMinWidth: getMinWidth,
			getMinHeight: getMinHeight,
		};

		const setContent = function (editor, html) {
			editor.focus();
			editor.undoManager.transact(function () {
				editor.setContent(html);
			});
			editor.selection.setCursorLocation();
			editor.nodeChanged();
		};
		const getContent = function (editor) {
			return editor.getContent({ source_view: true });
		};
		const Content = {
			setContent: setContent,
			getContent: getContent,
		};

		const ranges = {};

		const resetRange = (newTitle) => {
			const title = newTitle || '';
			ranges.title = title;
			ranges.positions = [];
			ranges.start = -1;
			ranges.finish = false;
		};
		resetRange();

		const find = (editor, originalText, findText, caseVal) => {
			let lastPosition = 0;
			const originalText_low = caseVal ? originalText : originalText.toLowerCase();
			const findText_low = caseVal ? findText : findText.toLowerCase();
			if (ranges.title !== findText_low) {
				resetRange(findText_low); // новый поиск, обнуление заголовка и позиций
			}

			if (ranges.positions[ranges.positions.length - 1] && ranges.positions[ranges.positions.length - 1].from > 0) {
				// продолжаем поиск с места клика или дальше
				lastPosition = ranges.positions[ranges.positions.length - 1].from + findText_low.length;
			} else {
				lastPosition = ranges.start > -1 ? ranges.start : 0;
			}
			if (ranges.start !== -1) {
				// управление по клику на текстовом поле, обнуляем всё, что позже
				ranges.positions = ranges.positions.map((item) => item.from < ranges.start);
				ranges.start = 0;
			}

			// собственно поиск первого вхождения с lastPosition
			let startFrom = originalText_low.indexOf(findText_low, lastPosition);

			if (startFrom > -1) {
				ranges.positions.push({ from: startFrom, to: startFrom + findText_low.length });
			}
			if (startFrom === -1 && ranges.start === -1) {
				ranges.start = 0;
				ranges.finish = true; // для замены всего, защита от зацикливания
			}
			// console.log('startFrom', startFrom, ', ranges.start', ranges.start, ranges.finish);
			return { from: startFrom, to: startFrom + findText_low.length };
		};

		const replace = (editor, originalText, findText, replaceText, caseVal) => {
			if (!replaceText || !findText || !originalText) return false;
			let newText;

			if (ranges.positions.length) {
				// замена по последней найденной позиции
				const sPosition = ranges.positions[ranges.positions.length - 1].from;
				newText =
					originalText.substring(0, sPosition) +
					replaceText +
					originalText.substring(sPosition + findText.length, originalText.length);
				resetRange(findText);
				ranges.start = sPosition + findText.length;
			} else {
				// новый поиск и замена
				const fPositions = Actions.find(editor, originalText, findText, caseVal);
				if (fPositions && fPositions.from > -1) {
					newText =
						originalText.substring(0, fPositions.from) +
						replaceText +
						originalText.substring(fPositions.from + findText.length, originalText.length);
				}
				resetRange();
			}

			return newText;
		};

		const replaceAll = (editor, originalText, findText, replaceText, caseVal) => {
			if (!replaceText || !findText || !originalText) return false;
			let newText;
			if (caseVal) {
				// с учётом регистра
				newText = originalText.replaceAll(findText, replaceText);
			} else {
				// без учёта регистра - поиск и замена поштучно, пока не закончатся поисковые варианты ranges.finish = true
				resetRange();
				// console.log('replace registry', caseVal, ranges);
				let position = Actions.find(editor, originalText, findText, caseVal);
				newText = originalText;
				if (position && position.from !== -1) {
					// первый проход
					newText =
						newText.substring(0, position.from) +
						replaceText +
						newText.substring(position.from + findText.length, newText.length);
					position = Actions.find(editor, newText, findText, caseVal);
				}

				while (position && position.from && !ranges.finish) {
					newText =
						newText.substring(0, position.from) +
						replaceText +
						newText.substring(position.from + findText.length, newText.length);
					position = Actions.find(editor, newText, findText, caseVal);
				}
			}

			return newText;
		};

		var Actions = {
			find: find,
			replace: replace,
			replaceAll: replaceAll,
		};

		var open = function (editor) {
			var minWidth = Settings.getMinWidth(editor);
			var minHeight = Settings.getMinHeight(editor) - 100;

			function updateButtonStates() {
				// console.log(win.find('#replace').value());
				const val = win.find('#replace').value();
				const isEmpty = val.length === 0;
				win.statusbar.find('#Replace').disabled(isEmpty);
				win.statusbar.find('#ReplaceAll').disabled(isEmpty);
			}

			var win = editor.windowManager.open({
				layout: 'flex',
				title: 'Source code',
				// body: {
				// 	type: 'textbox',
				// 	name: 'code',
				// 	multiline: true,
				// 	minWidth: minWidth,
				// 	minHeight: minHeight,
				// 	spellcheck: false,
				// 	style: 'direction: ltr; text-align: left',
				// },
				onSubmit: function (evt) {
					Content.setContent(editor, evt.data.code);
				},
				buttons: [
					{
						text: 'Find',
						class: 'btn-hover',
						onclick: function () {
							const caseVal = win.find('#case').value();
							const range = Actions.find(editor, win.find('#code').value(), win.find('#find').value(), caseVal);
							win.find('#code')[0].$el.selectRange = function (start, end) {
								return this.each(function () {
									if (this.setSelectionRange) {
										this.setSelectionRange(start, end);
										this.focus();
									} else if (this.createTextRange) {
										var range = this.createTextRange();
										range.collapse(true);
										range.moveEnd('character', end);
										range.moveStart('character', start);
										range.select();
									}
								});
							};
							win.find('#code')[0].$el.selectRange(range.from, range.to);
						},
					},
					{
						text: 'Replace',
						name: 'Replace',
						class: 'btn-hover',
						disabled: true,
						onclick: function () {
							const caseVal = win.find('#case').value();
							const newText = Actions.replace(
								editor,
								win.find('#code').value(),
								win.find('#find').value(),
								win.find('#replace').value(),
								caseVal,
							);
							if (newText) win.find('#code').value(newText);
						},
					},
					{
						text: 'Replace all',
						name: 'ReplaceAll',
						class: 'btn-hover',
						disabled: true,
						onclick: function () {
							const findText = win.find('#find').value();
							const replaceText = win.find('#replace').value();
							const caseVal = win.find('#case').value();
							if (window.confirm(`Заменить все вхождения "${findText}" на "${replaceText}"?`) === false) {
								return;
							}
							const newText = Actions.replaceAll(editor, win.find('#code').value(), findText, replaceText, caseVal);

							if (newText) win.find('#code').value(newText);
						},
					},
					{
						type: 'spacer',
						flex: 1,
					},
					{
						text: 'Ok',
						subtype: 'primary',
						onclick: function () {
							win.submit();
						},
					},
					{
						text: 'Cancel',
						onclick: function () {
							win.close();
						},
					},
				],
				items: {
					type: 'form',
					padding: 20,
					labelGap: 30,
					spacing: 10,
					items: [
						{
							type: 'textbox',
							name: 'code',
							multiline: true,
							minWidth: minWidth,
							minHeight: minHeight,
							spellcheck: false,
							style: 'direction: ltr; text-align: left',
							onclick: function () {
								this.getCursorPosEnd = function () {
									var pos = 0;
									var input = this.$el[0];
									// IE Support
									if (document.selection) {
										input.focus();
										var sel = document.selection.createRange();
										pos = sel.text.length;
									}
									// Firefox support
									else if (input.selectionStart || input.selectionStart === '0') pos = input.selectionEnd;

									return pos;
								};
								const clickPos = this.getCursorPosEnd();
								// console.log(clickPos);
								ranges.start = clickPos; // задаём точку старта для дальнейшего поиска
							},
							onkeyup: function (evt) {
								this.getCursorPosEnd = function () {
									var pos = 0;
									var input = this.$el[0];
									// IE Support
									if (document.selection) {
										input.focus();
										var sel = document.selection.createRange();
										pos = sel.text.length;
									}
									// Firefox support
									else if (input.selectionStart || input.selectionStart === '0') pos = input.selectionEnd;

									return pos;
								};
								if (['ArrowDown', 'ArrowUp', 'ArrowRight', 'ArrowLeft', 'Home'].indexOf(evt.code) !== -1) {
									const clickPos = this.getCursorPosEnd();
									// console.log(evt.code, clickPos);
									ranges.start = clickPos; // задаём точку старта для дальнейшего поиска
								}
							},
						},
						{
							type: 'textbox',
							name: 'find',
							size: 40,
							label: 'Find',
							value: '',
						},
						{
							type: 'textbox',
							name: 'replace',
							size: 40,
							label: 'Replace with',
							onkeyup: function () {
								updateButtonStates();
							},
						},
						{
							type: 'checkbox',
							name: 'case',
							text: 'Match case',
							label: ' ',
						},
						// {
						// 	type: 'checkbox',
						// 	name: 'words',
						// 	text: 'Whole words',
						// 	label: ' ',
						// },
					],
				},
			});
			win.find('#code').value(Content.getContent(editor));
		};
		var Dialog = { open: open };

		var register = function (editor) {
			editor.addCommand('mceCodeEditor', function () {
				Dialog.open(editor);
				editor.undoManager.add();
			});
		};
		var Commands = { register: register };

		var register$1 = function (editor) {
			editor.addButton('codemod', {
				icon: 'code',
				tooltip: 'Source code',
				onclick: function () {
					Dialog.open(editor);
					editor.undoManager.add();
				},
			});

			editor.addMenuItem('code', {
				icon: 'code',
				text: 'Source code',
				onclick: function () {
					Dialog.open(editor);
				},
			});
		};
		var Buttons = { register: register$1 };

		global.add('codemod', function (editor) {
			Commands.register(editor);
			Buttons.register(editor);

			return Content;
		});
		function Plugin() {}

		return Plugin;
	})();
})();
